import type { RefundDataSource } from '~/api/data-source/refund';
import { refundDataSource } from '~/api/data-source/refund';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type RefundAccount = OAISchema['MarketPaymentRefundAccountResponse'];
type RefundAccountCheckResult = OAISchema['PaymentRefundAccountCheckResponse'];
type Bank = OAISchema['Bank'];

// Request 타입
type RefundAccountRequestV2 = OAISchema['PaymentRefundAccountRequestV2'];
type ValidateAccountHolderRequest =
  OAISchema['MarketPaymentValidateAccountHolderRequest'];
type RefundAccountCheckRequest = OAISchema['PaymentRefundAccountCheckRequest'];

export interface RefundRepository {
  // Query
  getRefundAccount(): Promise<RefundAccount>;
  getRefundBankList(): Promise<Bank[]>;

  // Mutation
  updateRefundAccount(data: RefundAccountRequestV2): Promise<RefundAccount>;
  validateAccountHolder(
    data: ValidateAccountHolderRequest,
  ): Promise<RefundAccount>;
  checkRefundAccount(
    data: RefundAccountCheckRequest,
  ): Promise<RefundAccountCheckResult>;
}

export class RefundRepositoryImpl implements RefundRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: RefundDataSource = refundDataSource,
  ) {}

  async getRefundAccount() {
    return this.dataSource.getRefundAccount();
  }

  async getRefundBankList() {
    return this.dataSource.getRefundBankList();
  }

  async updateRefundAccount(data: RefundAccountRequestV2) {
    return this.dataSource.updateRefundAccount(data);
  }

  async validateAccountHolder(data: ValidateAccountHolderRequest) {
    return this.dataSource.validateAccountHolder(data);
  }

  async checkRefundAccount(data: RefundAccountCheckRequest) {
    return this.dataSource.checkRefundAccount(data);
  }
}

export const refundRepository = new RefundRepositoryImpl();
